module.exports = __webpack_public_path__ + "img/0Q3A2198_L_Wood.01b52c4b.jpg";